import RequestInstance from '../request.instance';
import { IBindInviteReq, IAuthLoginReq, IGetInviteListReq, IRelationUserReq } from './referral.request.interface';
import { IBindInvite, IEmailLogin, IHistoryOrder, IInvite, IRelationUser, IUerInfo, IUnsettledLimitOrder } from './referral.response.interface';

export class ReferralApiService {
  private readonly requestInstance: RequestInstance;
  constructor() {
    this.requestInstance = new RequestInstance();
  }

  // 邮箱用户登录
  async emailLogin(data: IAuthLoginReq): Promise<IEmailLogin> {
    return await this.requestInstance.referralRequest({
      url: '/auth/login',
      method: 'POST',
      data,
    });
  }

  // 绑定一个没有推荐关系的用户
  async bindUser(data: IBindInviteReq): Promise<IBindInvite> {
    return await this.requestInstance.referralRequest({
      url: '/user/bind-referrer',
      method: 'POST',
      data,
    });
  }

  // 获取用户信息
  async getUserInfo(): Promise<IUerInfo> {
    return await this.requestInstance.referralRequest({
      url: '/user/profile',
      method: 'GET',
    });
  }

  // 获取邀请分页列表
  async getInviteList(params: IGetInviteListReq): Promise<{ items: IInvite[] }> {
    return await this.requestInstance.referralRequest({
      url: '/user/invite-list',
      method: 'GET',
      params,
    });
  }

  // 关联用户
  async createRelationUser(data: IRelationUserReq): Promise<IRelationUser> {
    return await this.requestInstance.referralRequest({
      url: '/user/create/relation',
      method: 'POST',
      data,
    });
  }

  // 获取历史订单
  async getLimitOrderHistoryList(params: { wallet: string; page: number }): Promise<{ orders: IHistoryOrder[] }> {
    return await this.requestInstance.referralRequest({
      url: '/privy/boom/limit-history',
      method: 'GET',
      params,
    });
  }

  // 获取未结算的订单列表
  async getUnsettledLimitOrderList(params: { wallet: string; inputMint?: number; outputMint?: number }): Promise<IUnsettledLimitOrder[]> {
    return await this.requestInstance.referralRequest({
      url: '/privy/boom/limit-orders',
      method: 'GET',
      params,
    });
  }

  // 提取奖励
  async withdrawReward(): Promise<any> {
    return await this.requestInstance.referralRequest({
      url: '/user/withdraw/reward',
      method: 'POST',
    });
  }
}

export default new ReferralApiService();
